import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Input, Switch } from 'element-react'

const MaintenanceModeDataDialog = props => {
    const { cancel, updateData, show, currentMessage, currentLink } = props
    const [message, setMessage] = useState('')
    const [link, setLink] = useState('')
    const [linkText, setLinkText] = useState('')
    const [showLinkInputs, setShowLinkInputs] = useState(false)

    useEffect(() => {
        setMessage(currentMessage || '')
    }, [currentMessage])

    useEffect(() => {
        if (currentLink && currentLink.hasLink) {
            setLink(currentLink.link || '')
            setLinkText(currentLink.linkText || '')
            setShowLinkInputs(true)
        } else {
            setLink('')
            setLinkText('')
            setShowLinkInputs(false)
        }
    }, [currentLink])

    const handleToggleLinkInputs = value => {
        setShowLinkInputs(value)
        if (!value) {
            setLink('')
            setLinkText('')
        }
    }

    const handleConfirm = () => {
        const data = {
            message,
            link: showLinkInputs ? link : '',
            linkText: showLinkInputs ? linkText : '',
        }
        updateData(data)
    }

    return (
        show && (
            <Dialog
                className="request-type-dialog"
                size="large"
                top="10%"
                title=" "
                visible={true}
                onCancel={cancel}
            >
                <Dialog.Body>
                    <div className="row max400">
                        <div className="text-xl font-bold">
                            Update Maintenance Mode Data
                        </div>
                        <p>
                            Update the message and link that will be displayed
                            to users during maintenance mode.
                        </p>

                        <div className="mt-5 mb-5">
                            <label className="block mb-2 text-lg font-bold">
                                Maintenance Message:
                            </label>
                            <Input
                                type="textarea"
                                rows={4}
                                value={message}
                                onChange={setMessage}
                                placeholder="Enter a message to display to users during maintenance..."
                                maxLength={300}
                            />
                            <div className="text-right mt-1 text-xs text-gray-600">
                                {message.length}/300 characters
                            </div>

                            <div className="mt-6 mb-3 flex items-center">
                                <label className="mr-3 text-lg font-bold">
                                    Add Maintenance Link
                                </label>
                                <Switch
                                    value={showLinkInputs}
                                    onChange={handleToggleLinkInputs}
                                />
                            </div>

                            {showLinkInputs && (
                                <>
                                    <label className="block mb-2 mt-5 text-lg font-bold">
                                        Maintenance Link Text:
                                    </label>
                                    <Input
                                        value={linkText}
                                        onChange={setLinkText}
                                        placeholder="This is what the users will see (e.g., 'Click here for updates')..."
                                        maxLength={100}
                                    />
                                    <div className="text-right mt-1 text-xs text-gray-600">
                                        {linkText.length}/100 characters
                                    </div>

                                    <label className="block mb-2 mt-5 text-lg font-bold">
                                        Maintenance Link URL:
                                    </label>
                                    <Input
                                        value={link}
                                        onChange={setLink}
                                        placeholder="Enter link URL (e.g., 'https://status.example.com')..."
                                        maxLength={200}
                                    />
                                    <div className="text-right mt-1 text-xs text-gray-600">
                                        {link.length}/200 characters
                                    </div>

                                    {/* {linkText && link && (
                                        <div className="mt-6 p-4 bg-gray-100 rounded border border-gray-300">
                                            <label className="block mb-2 text-sm font-bold text-gray-700">
                                                Link preview (as it will appear
                                                on maintenance page):
                                            </label>
                                            <div className="bg-white p-4 rounded">
                                                <p className="text-2xl font-medium max-w-2xl">
                                                    <a
                                                        href={link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-yellow hover:underline"
                                                    >
                                                        {linkText}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    )} */}
                                </>
                            )}
                        </div>

                        <div className="text-right mt-8">
                            <Button onClick={cancel}>Cancel</Button>
                            <Button type="primary" onClick={handleConfirm}>
                                Update
                            </Button>
                        </div>
                    </div>
                </Dialog.Body>
            </Dialog>
        )
    )
}

MaintenanceModeDataDialog.propTypes = {
    cancel: PropTypes.func.isRequired,
    updateData: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    currentMessage: PropTypes.string,
    currentLink: PropTypes.shape({
        link: PropTypes.string,
        linkText: PropTypes.string,
        hasLink: PropTypes.bool,
    }),
}

export default MaintenanceModeDataDialog
